import React, { useState } from 'react';
import { AdminSidebar } from './AdminSidebar';
import { useAuth } from '../contexts/AuthContext';
import { ArrowLeft, Eye } from 'lucide-react';
interface AdminLayoutProps {
  children: React.ReactNode;
}
export function AdminLayout({
  children
}: AdminLayoutProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const {
    user,
    isImpersonating,
    stopImpersonating
  } = useAuth();
  return <div className="flex min-h-screen bg-gray-50 font-sans text-gray-900 overflow-x-hidden" data-id="element-88">
      <AdminSidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} data-id="element-89" />

      <div className="flex-1 flex flex-col lg:pl-64 min-h-screen min-w-0 w-full" data-id="element-90">
        {/* Impersonation Banner */}
        {isImpersonating && <div className="sticky top-0 z-50 bg-amber-500 text-white px-4 py-2.5 flex items-center justify-between text-sm font-medium shadow-md lg:top-0" data-id="element-91">
            <div className="flex items-center gap-2" data-id="element-92">
              <Eye size={16} className="shrink-0" data-id="element-93" />
              <span data-id="element-94">
                Estás viendo el panel como{' '}
                <strong className="font-bold" data-id="element-95">{user?.name}</strong>
                {user?.username && <span className="opacity-75 font-normal ml-1" data-id="element-96">
                    (@{user.username})
                  </span>}
              </span>
            </div>
            <button onClick={stopImpersonating} className="flex items-center gap-1.5 bg-white/20 hover:bg-white/30 active:bg-white/40 px-3 py-1.5 rounded-lg transition-colors text-xs font-semibold whitespace-nowrap ml-4" data-id="element-97">
              <ArrowLeft size={14} data-id="element-98" />
              Volver a mi cuenta
            </button>
          </div>}

        <main className="flex-1 overflow-x-hidden pt-16 lg:pt-0 min-w-0" data-id="element-99">
          {children}
        </main>
      </div>
    </div>;
}